import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { AgentStatusService } from 'app/core/agent-status/agent-status.service';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { AgentStatus } from 'app/core/workspace/workspace.types';
import { WorkspaceService } from 'app/core/workspace/workspace.service';
import { AgentStatusBadgeComponent } from 'app/shared/agent-status-badge/agent-status-badge.component';
import { Subject, takeUntil } from 'rxjs';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        MatMenuModule,
        MatIconModule,
        MatDividerModule,
        TranslocoModule,
        AgentStatusBadgeComponent,
    ],
})
export class UserComponent implements OnInit, OnDestroy {
    user: User;
    myStatus: AgentStatus | null = null;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private _userService: UserService,
        private _router: Router,
        private _agentStatusService: AgentStatusService,
        private _workspaceService: WorkspaceService
    ) {}

    ngOnInit(): void {
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                this.user = user;
            });

        this._agentStatusService.myStatus$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((status) => {
                this.myStatus = status;
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    onStatusChange(status: AgentStatus): void {
        const workspaceId = this._workspaceService.currentSelectedWorkspace?._id;
        if (workspaceId) {
            this._agentStatusService.setStatus(status, workspaceId).subscribe({ error: () => {} });
        }
    }

    signOut(): void {
        this._router.navigate(['/sign-out']);
    }
}
